export enum ScanJobStatus {
  QUEUED = 'QUEUED',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  // Hit the message-count/time budget before finishing the full window —
  // distinct from COMPLETED so the UI can say "showing a partial result"
  // instead of implying every message in the window was read.
  COMPLETED_TRUNCATED = 'COMPLETED_TRUNCATED',
  FAILED = 'FAILED',
}

export const TERMINAL_SCAN_JOB_STATUSES: ScanJobStatus[] = [
  ScanJobStatus.COMPLETED,
  ScanJobStatus.COMPLETED_TRUNCATED,
  ScanJobStatus.FAILED,
];

/**
 * Bounded set of failure reasons the scan worker can attribute a FAILED job
 * to. `ScanJob.error` stores ONLY one of these codes — never the raw
 * upstream error text (a Gmail API error can embed an email address, a
 * message id, or the query) — so the persisted row never carries
 * identifying content. The full raw error still goes to `log.error` for
 * debugging; this enum is what's allowed to reach DynamoDB.
 */
export enum ScanFailureCode {
  TIMEOUT = 'TIMEOUT',
  INVALID_MESSAGE = 'INVALID_MESSAGE',
  UNKNOWN = 'UNKNOWN',
}

export interface ScanJob {
  id: string;
  userId: string;
  status: ScanJobStatus;
  windowHours: number;
  messagesRead: number;
  startedAt?: number;
  finishedAt?: number;
  error?: ScanFailureCode;
  createdAt: number;
  updatedAt: number;
}

export enum ScanQueueMessageType {
  START_SCAN = 'START_SCAN',
}

/**
 * Body of the single message the scanRecentCommunications mutation enqueues
 * onto the scan worker's queue. The worker (apps/api/src/sqs, built
 * separately) MUST consume this type rather than inventing a parallel one —
 * it is the producer/consumer contract between the GraphQL feature
 * (features/scanJobs) and that queue.
 */
export interface StartScanQueueBody {
  messageType: ScanQueueMessageType.START_SCAN;
  userId: string;
  scanJobId: string;
  windowHours: number;
}

export type ScanQueueBody = StartScanQueueBody;
